<template>
  <div>
    <LeftContainer id="left-containter" />
    <RightContainer id="right-container" />
  </div>
</template>

<script>
import LeftContainer from "./LeftContainer";
import RightContainer from "./RightContainer";

export default {
  components: {
    LeftContainer: LeftContainer,
    RightContainer: RightContainer
  }
};
</script>

<style>
#left-containter {
  position: absolute;
  top: 0;
  width: 330px;
}

#right-container {
  margin-left: 350px;
}
</style>